export enum FinanceDistributionModelingRoundModalMode {
  CREATE = "create",
  VIEW = "view",
  EDIT = "edit",
}

export enum FinanceDistributionModelingProjectModalMode {
  VIEW = "view",
  EDIT = "edit",
}
